export default {


    async registerMember(context, data) {

        const member = {
            firstName: data.firstName,
            lastName: data.lastName,
            spouse: data.spouse,
            children: data.children,
            houseHold: data.houseHold,
            connectionGroup: data.connectionGroup,
            dateFirstContact: data.dateFirstContact,
            dateLastContact: data.dateLastContact,
            notes: data.notes
        }
        const token = context.rootGetters.token;
        await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members.json?auth=` + token, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                firstName: data.firstName,
                lastName: data.lastName,
                spouse: data.spouse,
                children: data.children,
                houseHold: data.houseHold,
                connectionGroup: data.connectionGroup,
                dateFirstContact: data.dateFirstContact,
                dateLastContact: data.dateLastContact,
                notes: [],
            })
        });

        context.commit('addMember', { ...member });
    },

    async removeMember(context, data) {

        const member = context.getters.members.find(m => m.id === data.id);
        const token = context.rootGetters.token;
        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members/${member.id}.json?auth=` + token, {
            method: 'DELETE'
        });

        const responseData = await response.json();

        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }


        context.commit('removeMember', data);
    },


    async addNoteToMember(context, data) {
        const member = context.getters.members.find(m => m.id === data.id);
        const token = context.rootGetters.token;

        const res = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members/${member.id}/notes.json?auth=` + token, {
            method: 'POST',
            body: JSON.stringify({
                note: data.note
            })
        });
        const responseData = await res.json();
        if (!res.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }

        const paylod = {
            memberId: member.id,
            id: responseData.name,
            note: data.note
        }

        context.commit('addNoteToMember', paylod);
    },


    async removeNote(context, payload) {
        console.log('removeNote', payload)
        const token = context.rootGetters.token;
        const member = context.getters.members.find(m => m.id === payload.id);
        console.log('group notes', member.notes)

        await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members/${member.id}/notes/${payload.noteId}.json?auth=` + token, {
            method: 'DELETE'
        });
        context.commit('removeNoteFromMember', payload);
    },


    async addGroupToMember(context, data) {

        const member = context.getters.members.find(m => m.id === data.memberId);
        if (member.connectionGroup) {
            context.dispatch('removeGroupFromMember', data)
            context.dispatch('groups/removeFromGroup', { id: member.connectionGroup.groupId, memberId: member.id }, { root: true })
        }
        const token = context.rootGetters.token;
        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members/${member.id}.json?auth=` + token, {
            method: 'PATCH',
            body: JSON.stringify({
                dateLastContact: data.date
            })
        });
        const responseData = await response.json();
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }
        context.commit('addGroupToMember', data);
    },

    async removeGroupFromMember(context, data) {

        const id = data.memberId
        const member = context.getters.members.find(m => m.id === id);
        const token = context.rootGetters.token;

        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members/${member.id}.json?auth=` + token, {
            method: 'PATCH',
            body: JSON.stringify({
                connectionGroup: null
            })
        });

        const responseData = await response.json();
        console.log('responseData', responseData)
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }

        context.commit('removeGroup', id);
    },

    async changeLastContactedDate(context, data) {

        console.log('data in change last contactdate', data)
        console.log(typeof data.date)
        const member = context.getters.members.find(m => m.id === data.id);
        const token = context.rootGetters.token;


        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members/${member.id}.json?auth=` + token, {
            method: 'PATCH',
            body: JSON.stringify({
                dateLastContact: data.date
            })
        });

        const responseData = await response.json();
        console.log(responseData)
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }

        context.commit('changeLastContactDate', data)
    },

    async loadMembers(context, payload) {

        console.log(payload);

        const response = await fetch(`https://trackingmembers-a1654-default-rtdb.firebaseio.com/members.json`
        );
        const responseData = await response.json();
        if (!response.ok) {
            const error = new Error(responseData.message || 'Failed to fetch!');
            throw error;
        }
        const members = []

        for (const key in responseData) {
            const member = {
                id: key,
                firstName: responseData[key].firstName,
                lastName: responseData[key].lastName,
                spouse: responseData[key].spouse,
                children: responseData[key].children,
                houseHold: responseData[key].houseHold,
                connectionGroup: responseData[key].connectionGroup,
                dateFirstContact: responseData[key].dateFirstContact = new Date(responseData[key].dateFirstContact),
                dateLastContact: responseData[key].dateLastContact = new Date(responseData[key].dateLastContact),
                notes: responseData[key].notes
            };
            const notesToIterAte = member.notes
            let newNotes = []
            for (const key in notesToIterAte) {
                const note = {
                    id: key,
                    note: notesToIterAte[key].note
                }
                newNotes.push(note)
                member.notes = newNotes;
            }

            members.push(member);
        }


        context.commit('setMembers', members);
    }

}







